import React from 'react';
import CommonModal from '../../../extras/commonModal';
import { TextField } from '@material-ui/core';

const disabledBlackTextStyle = {
  InputProps: {
    style: { color: '#000' },
  },
  InputLabelProps: {
    style: { color: '#000' },
  },
};

const formatDate = (dateString) => {
  if (!dateString || dateString === 'N/A') return 'N/A';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// const formatArrayData = (data) => {
//   if (!data) return 'N/A';
//   if (Array.isArray(data)) {
//     return data.length > 0 ? data.join(', ') : 'Not specified';
//   }
//   return data;
// };

const ViewRowData = ({ isOpen, setIsOpen, currentRowData }) => {
  if (!currentRowData) return null;

  // Extract questions for detail grid
  const questionsArr = currentRowData.questions
    ? Object.entries(currentRowData.questions).map(([q, v]) => ({
        question: q,
        rating: v.rating,
        remark: v.remark,
      }))
    : [];

  return (
    <CommonModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      classStyle='w-[900px] h-auto max-h-[90vh] rounded-md'
    >
      <div className='modal-content hide-scrollbar'>
        {/* Header */}
        <div className='modal-header mb-4'>
          <h2 className='modal-title text-xl font-semibold'>Progress Call Details</h2>
          <p className='modal-subtitle text-gray-500'>User ID: {currentRowData.userId}</p>
        </div>

        {/* Info Grid */}
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
          <TextField label='Name' value={`${currentRowData.firstName || ''} ${currentRowData.lastName || ''}`} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Email' value={currentRowData.email || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Phone' value={currentRowData.phone || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Program' value={`${currentRowData.courseType || ''} ${currentRowData.planType || ''} ${currentRowData.subPlanType || ''}`} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Cohort Name' value={currentRowData.cohortName || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Almax Cohort Name' value={currentRowData.almaxCohortName || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Enrolment On' value={formatDate(currentRowData.enrolmentOn)} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Progress' value={currentRowData.progress || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Progress Updated At' value={formatDate(currentRowData.progressUpdatedAt)} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='POC' value={currentRowData.POC || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Contact Date' value={formatDate(currentRowData.contactDate)} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Call Status' value={currentRowData.callStatus || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Overall Remark' value={currentRowData.overallRemark || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} multiline minRows={2} InputProps={{...disabledBlackTextStyle.InputProps, style: { ...disabledBlackTextStyle.InputProps.style, whiteSpace: 'pre-line', wordBreak: 'break-word', overflow: 'hidden' }}} />
          <TextField label='POC Remark' value={currentRowData.pocRemark || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} multiline minRows={2} InputProps={{...disabledBlackTextStyle.InputProps, style: { ...disabledBlackTextStyle.InputProps.style, whiteSpace: 'pre-line', wordBreak: 'break-word', overflow: 'hidden' }}} />
          <TextField label='Care' value={currentRowData.care || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Exotel Reference' value={currentRowData.exotelReference || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='QA Status' value={currentRowData.qaStatus || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='QA Remark' value={currentRowData.qaRemark || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} multiline minRows={2} InputProps={{...disabledBlackTextStyle.InputProps, style: { ...disabledBlackTextStyle.InputProps.style, whiteSpace: 'pre-line', wordBreak: 'break-word', overflow: 'hidden' }}} />
          <TextField label='Calling Round' value={currentRowData.callingRound || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Average Rating' value={currentRowData.averageRating || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
          <TextField label='Upload Name' value={currentRowData['type-name'] || 'N/A'} disabled variant='outlined' fullWidth {...disabledBlackTextStyle} />
        </div>

        {/* Questions Section */}
        <div className='mb-4'>
          <h3 className='font-semibold mb-2'>Questions & Ratings</h3>
          {questionsArr?.length > 0 ? (
            <div className='overflow-x-auto'>
              <table className='min-w-full border border-gray-200 rounded'>
                <thead>
                  <tr className='bg-gray-100'>
                    <th className='px-3 py-2 text-left'>Question</th>
                    <th className='px-3 py-2 text-left'>Rating</th>
                    <th className='px-3 py-2 text-left'>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {questionsArr.map((q, idx) => (
                    <tr key={idx} className='border-t'>
                      <td className='px-3 py-2 align-top'>{q.question}</td>
                      <td className='px-3 py-2 align-top'>{q.rating ?? 'N/A'}</td>
                      <td className='px-3 py-2 align-top break-all'>{q.remark ?? 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='text-gray-500'>No questions data available.</div>
          )}
        </div>
      </div>
    </CommonModal>
  );
};

export default ViewRowData;